export const alocacao = {
  titulo: 'Allocations',
  descricao:
    'Percentage of professionals allocated to projects, with BR/US cost share. Professionals with more than one allocation are under Checks > Multi-allocated.',
  nova: 'New allocation',
  filtros: {
    profissional: 'Professional',
    projeto: 'Project',
    contrato: 'Contract',
    cliente: 'Client',
    anotacoes: 'Notes',
    anotacoesLimite: 'Use at most {{max}} characters.',
    alocar: 'Allocate',
    descartarTitulo: 'Discard changes?',
    descartarDescricao: 'What you filled in for this allocation will be lost.',
    descartar: 'Discard',
    continuarEditando: 'Keep editing',
    anotacoesPlaceholder: 'Search by notes…',
    buscarPlaceholder: 'Search by name or code…',
    profissionaisPlaceholder: 'Select one or more professionals…',
    buscando: 'Searching…',
    semResultados: 'No results found.',
    limpar: 'Clear filters',
    limparSelecao: 'Clear selection',
    periodoInicio: 'Start',
    periodoFim: 'End',
    periodoFimHint: 'Overlaps with the allocation period. Empty = onward from Start.',
    codigoOuNomePlaceholder: 'Code or name…',
    nomeOuMatriculaPlaceholder: 'Name or registration…',
    avancados: 'Advanced filters',
    aplicados: 'Applied filters',
    avancadosDescricao:
      'The fields follow the visible table columns: show or hide columns in "Columns" to change the available filters.',
    percentualMinimo: 'Minimum allocation %',
    percentualMaximo: 'Maximum allocation %',
    contratoDoClienteHint: "Listing only the selected client's contracts.",
    mostrandoDeTotal: 'Showing {{shown}} of {{total}}. Type to narrow down.',
    aplicar: 'Apply filters',
    cancelar: 'Cancel',
    totalProfissionais_one: 'Showing {{showing}} of {{count}} professional',
    totalProfissionais_other: 'Showing {{showing}} of {{count}} professionals',
    chips: {
      contem: '{{field}} contains "{{value}}"',
      percentualEntre: '% allocated between {{min}} and {{max}}',
      percentualMinimo: '% allocated from {{min}}',
      percentualMaximo: '% allocated up to {{max}}',
      selecionado: '{{field}}: {{name}}',
      profissionais_one: 'Professional',
      profissionais_other: 'Professionals',
      eMais: '{{names}} and {{count}} more',
      periodoEntre: 'Period: {{start}} to {{end}}',
      periodoDesde: 'Period: from {{start}}',
      periodoAte: 'Period: until {{end}}',
      remover: 'Remove filter: {{filter}}',
    },
  },
  tabela: {
    profissional: 'Professional',
    projeto: 'Project',
    contrato: 'Contract',
    cliente: 'Client',
    percAlocado: '% allocated',
    faturando: 'Billable',
    inicio: 'Start',
    fim: 'End',
    unidade: 'Unit',
    custoBrUs: 'BR/US cost',
    perfilVenda: 'Sales profile',
    custoAlocado: 'Allocated cost',
    diretorConta: 'Account Director',
    gerenteOperacao: 'Operations Manager',
    gerenteProjeto: 'Project Manager',
    custoMes: 'Monthly cost',
    fatBrutoMes: 'Monthly gross revenue',
    fatLiquidoMes: 'Monthly net revenue',
    ebitda: 'EBITDA %',
    acoes: 'Actions',
    acoesDaAlocacao: 'Actions for the allocation on {{projeto}}',
    semTermino: 'no end date',
    fimEstimado: 'estimated',
    br: 'BR',
    us: 'US',
    itensPorPagina: 'Items per page',
    profissionaisPorPagina: 'Professionals per page',
  },
  colunas: {
    titulo: 'Columns',
    visiveis: 'Visible columns',
    aplicar: 'Apply',
    redefinir: 'Reset',
    nenhumaSelecionada: 'Select at least one column.',
  },
  acoes: {
    visualizar: 'View',
    editar: 'Edit',
    encerrar: 'End',
  },
  estados: {
    escopoVazioTitulo: 'No project under your responsibility',
    escopoVazioDescricao:
      "You aren't a project manager, portfolio manager, or account director on any project yet. Contact the internal systems team if this isn't correct.",
    filtroSemResultadoTitulo: 'No allocations found',
    filtroSemResultadoDescricao: 'Adjust the filters or create a new allocation.',
  },
  linhaDoTempo: {
    barra: '{{projeto}}, {{percentual}}%',
    titulo: 'Timeline',
    tabela: 'Table',
    alternarVisao: 'Switch between table and timeline',
    semResultadoDescricao: 'Adjust the filters or the window to see allocations in this range.',
    periodo: 'Range',
    periodoMeses_one: '{{count}} month',
    periodoMeses_other: '{{count}} months',
    periodoPorFiltro: 'Range set by the Start and End filters.',
    statusFiltro: 'Filter by status',
    statusLabel: 'Status',
    irParaHoje: 'Go to today',
    hoje: 'Today',
    utilizacao: 'Utilization {{valor}}%',
    sobrealocadoValor: 'Overallocated +{{valor}}%',
    disponivel: 'Available',
    alocacoesContagem_one: '{{count}} allocation',
    alocacoesContagem_other: '{{count}} allocations',
    legenda: 'Legend',
    legendaAtiva: 'Active',
    legendaFutura: 'Upcoming',
    legendaEncerrada: 'Closed',
    legendaFaturavel: 'Billable',
    legendaNaoFaturavel: 'Non-billable',
    legendaFimEstimado: 'Estimated end',
    legendaSobrealocado: 'Overallocated',
  },
  form: {
    id: 'Id',
    novaTitulo: 'New allocation',
    editarTitulo: 'Edit allocation',
    visualizarTitulo: 'Allocation details',
    profissional: 'Professional',
    profissionalPlaceholder: 'Search by name or badge number…',
    projeto: 'Project',
    projetoPlaceholder: 'Search by code or name…',
    projetoSemContrato: 'Pick the contract to see its projects.',
    contrato: 'Contract',
    contratoPlaceholder: 'Search by code or name…',
    percAlocado: '% allocated',
    rateioCustoBr: 'BR cost share (%)',
    rateioCustoUs: 'US cost share (%)',
    rateioSomaErro: 'BR + US cost share must add up to 100%.',
    faturando: 'Billable',
    dtInicio: 'Start date',
    dtFim: 'End date',
    dtFimHint: 'Empty = no end date. Last covered day (inclusive).',
    fimConfirmado: 'End Confirmed',
    tags: 'Tags',
    tagsPlaceholder: 'Select tags…',
    tagsBuscarPlaceholder: 'Search tag…',
    tagsSemResultado: 'No tags found.',
    tagsRemover: 'Remove tag {{nome}}',
    anotacoes: 'Notes',
    perfilVenda: 'Sales profile',
    perfilVendaPlaceholder: 'Select the profile…',
    perfilVendaBuscar: 'Search profile…',
    perfilVendaNenhum: 'No sales profile',
    perfilVendaOpcao: '{{versao}} - {{nome}} - Rate: {{preco}}',
    perfilVendaSemContrato: 'Pick the contract to see its profiles.',
    custoMes: 'Monthly cost',
    custoMesHint: "Comes from the professional's contract; change it only to customize.",
    custoAlocado: 'Allocated cost',
    precoHora: 'Hourly rate',
    horasVendidas: 'Sold hours',
    fatBrutoMes: 'Monthly gross revenue',
    fatLiquidoMes: 'Monthly net revenue',
    projetoSemFaturamento:
      'Pool or internal projects do not bill: sales profile, rate, hours and revenue do not apply. The cost still applies.',
    avisado: 'Notified',
    avisadoEm: 'Notified on',
    numeroDias: 'Days given',
    fimPeloAviso: 'The end is calculated: notice date + days given. You can still change it.',
    bloqueioTitulo: 'Cannot save',
    avisoTitulo: 'Heads up',
  },
  encerrar: {
    titulo: 'End allocation',
    descricao:
      "End {{profissional}}'s allocation on {{projeto}}. The row isn't deleted — it just gets an end date.",
    dtFim: 'Last covered day',
    confirmar: 'End on {{data}}',
  },
  exportacao: {
    sucesso: 'File exported.',
    botao: 'Export',
    titulo: 'Export allocations',
    descricao: 'The table filters, searches, sort and visible columns apply to the file.',
    conteudo: 'Content',
    todasPaginas_one: 'All pages ({{count}} professional)',
    todasPaginas_other: 'All pages ({{count}} professionals)',
    paginaAtual_one: 'This page only ({{count}} professional)',
    paginaAtual_other: 'This page only ({{count}} professionals)',
    todasPaginasRegistros_one: 'All pages ({{count}} record)',
    todasPaginasRegistros_other: 'All pages ({{count}} records)',
    paginaAtualRegistros_one: 'This page only ({{count}} record)',
    paginaAtualRegistros_other: 'This page only ({{count}} records)',
    formato: 'Format',
    excel: 'Excel (.xlsx)',
    csv: 'CSV (.csv)',
    nomeArquivo: 'allocations',
  },
  lote: {
    selecionados_one: '{{count}} allocation selected',
    selecionados_other: '{{count}} allocations selected',
    gerenciarTags: 'Manage tags',
    limparSelecao: 'Clear selection',
    selecionarPagina: 'Select every allocation on the page',
    selecionarAlocacao: 'Select allocation {{projeto}}',
    titulo: 'Manage tags in bulk',
    descricao_one: 'Applies to the {{count}} selected allocation. Its other tags do not change.',
    descricao_other:
      'Applies to the {{count}} selected allocations. Their other tags do not change.',
    adicionar: 'Add tags',
    adicionarPlaceholder: 'Tags to apply…',
    remover: 'Remove tags',
    removerPlaceholder: 'Tags to take off…',
    removerSemResultado: 'The selected allocations do not have this tag.',
    conflito: 'A tag cannot be added and removed at the same time.',
    aplicar: 'Apply',
    sucesso_one: 'Tags updated on {{count}} allocation.',
    sucesso_other: 'Tags updated on {{count}} allocations.',
    ignoradas_one: '{{count}} allocation was not changed (outside your scope or already removed).',
    ignoradas_other:
      '{{count}} allocations were not changed (outside your scope or already removed).',
  },
  toasts: {
    criarSucesso: 'Allocation created successfully.',
    atualizarSucesso: 'Allocation updated successfully.',
    encerrarSucesso: 'Allocation ended successfully.',
    erro: 'Could not complete the operation.',
  },
  erros: {
    invalidPercentage: 'The allocated percentage must be between 1 and 100.',
    invalidCostShare: 'The BR + US cost share must add up to 100%.',
    endDateBeforeStartDate: 'The end date cannot be before the start date.',
    overlappingPeriod:
      'This professional already has an allocation on this project in this period.',
    projectOutOfScope: "This project isn't in your scope.",
    projectNotAllocatable: "This project doesn't accept new allocations.",
    professionalHasNoActiveContract: "This professional doesn't have an active contract.",
    sumAbove100: "This professional's allocations add up to {{total}}%.",
    unconfirmedWarnings: 'The warnings changed — review them before saving again.',
    allocationAlreadyClosed: 'This allocation has already ended.',
    allocationNotFound: 'This allocation no longer exists. Refresh the page.',
    noAxiisIdentity: "Your account doesn't have a matching AXIIS record.",
    inactiveAxiisIdentity: 'Your AXIIS record is inactive.',
    ambiguousAxiisIdentity: 'Your AXIIS record is ambiguous.',
    noAxiisIdentityGuidance: 'Contact the internal systems team to resolve this.',
    exportTooLarge: 'Too many rows to export. Narrow the filters and try again.',
    unknown: 'An unexpected error occurred.',
    salesProfileNotAllocatable:
      "The sales profile is not from the project's contract or is inactive.",
    invalidFinancialValue: 'Cost, rate and hours cannot be negative.',
    professionalOutOfScope:
      'This professional is not allocated in any of your projects. Ask an administrator to allocate them.',
    professionalNotAllocatable: 'This professional cannot be allocated.',
    tagNotFound: 'This tag no longer exists. Refresh the page.',
    tagNameTaken: 'A tag with this name already exists.',
    tagInactive: 'One of the tags is inactive and cannot be applied.',
    invalidTagBatch:
      'Pick at least one tag to add or remove, without repeating the same one in both lists.',
    tagInUse: 'The tag is linked to allocations and cannot be deleted. Deactivate it instead.',
    invalidManager: 'This manager is no longer active. Refresh the page and pick another.',
    projectNotFound: 'This project no longer exists. Refresh the page.',
  },
  consultas: {
    dataReferencia: 'Status on',
    total_one: '{{count}} record',
    total_other: '{{count}} records',
    colunas: {
      matricula: 'Registration',
      profissional: 'Professional',
      perfil: 'Profile',
      ultimaAlocacao: 'Last allocation',
      responsavel: 'Responsible',
      poolDesde: 'In pool since',
      avisado: 'Notified',
      avisadoEm: 'Notified on',
      numeroDias: 'Days given',
      moeda: 'Currency',
      fimAlocacao: 'Allocation end',
      tipo: 'Type',
      situacao: 'Status',
    },
    filtros: {
      nomeOuMatriculaPlaceholder: 'Name or registration…',
      todos: 'All',
      avancadosDescricao: 'Filter by one or more professionals, contract type, profile or status.',
    },
    pool: {
      titulo: 'Pool',
      totalCustoAlocado: 'Allocated cost total',
      descricao: 'Professionals allocated to pool projects on the selected day.',
      dataReferenciaDica: 'Shows who is in the pool on that day. Today by default.',
      editarAlocacaoDe: 'Edit the allocation of {{nome}}',
      vazioTitulo: 'No one in the pool on {{date}}',
      vazioDescricao: 'No allocation in force on that date in a project flagged as pool.',
      filtrosDescricao:
        'Filter by one or more professionals, profile, project, billing, notice, notes or tags.',
      filtroSemResultadoTitulo: 'No allocation found',
      filtroSemResultadoDescricao: 'Adjust or clear the filters to see who is in the pool.',
      exportarTitulo: 'Export Pool',
      nomeArquivo: 'pool',
    },
    semAlocacao: {
      titulo: 'Unallocated',
      descricao:
        'Contracts that are not closed, suspended or cancelled and have no allocation in force on the selected day.',
      dataReferenciaDica: 'Shows who is unallocated on that day. Today by default.',
      total_one: 'Showing {{showing}} of {{count}} unallocated contract',
      total_other: 'Showing {{showing}} of {{count}} unallocated contracts',
      vazioTitulo: 'Every contract has an allocation on {{date}}',
      vazioDescricao: 'Everyone is allocated to a project or to the pool.',
      filtroSemResultadoTitulo: 'No contract found',
      filtroSemResultadoDescricao: 'Adjust or clear the filters to see the unallocated contracts.',
      exportarTitulo: 'Export Unallocated',
      nomeArquivo: 'unallocated',
    },
    multialocados: {
      titulo: 'Multi-allocated',
      descricao:
        'Professionals with more than one allocation in force today, grouped by professional.',
      pesquisadosEmMultialocados_one:
        '{{count}} searched professional has more than one allocation and shows up in Multi-allocated.',
      pesquisadosEmMultialocados_other:
        '{{count}} searched professionals have more than one allocation and show up in Multi-allocated.',
      pesquisadosEmAlocacoes_one:
        '{{count}} searched professional has a single allocation and shows up in Allocations.',
      pesquisadosEmAlocacoes_other:
        '{{count}} searched professionals have a single allocation and show up in Allocations.',
      verEmMultialocados: 'See in Multi-allocated',
      verEmAlocacoes: 'See in Allocations',
      pesquisaAbertaEmMultialocados:
        'Who you searched for has more than one allocation, so the search opened in Multi-allocated.',
      pesquisaAbertaEmAlocacoes:
        'Who you searched for has a single allocation, so the search opened in Allocations.',
    },
    sintese: {
      titulo: 'Allocation summary',
      descricao:
        'Headcount projection by cost center over the coming weeks, derived from the dates of the allocations in force.',
      dataReferenciaDica: 'Projection baseline. Today by default.',
      horizonte: 'Horizon',
      horizonteSemanas_one: '{{count}} week',
      horizonteSemanas_other: '{{count}} weeks',
      centroCusto: 'Cost center',
      secaoBR: 'NT BR',
      secaoUS: 'NT US',
      total: 'Total',
      semanaDe: 'Week of {{date}}',
      variacao: 'Headcount change from the previous week',
      vazioTitulo: 'No allocations to project on {{date}}',
      vazioDescricao: 'There are no allocations in force to build the cost-center projection.',
      exportarTitulo: 'Export summary',
      exportarDescricao: 'The chosen reference date and horizon apply to the file.',
      nomeArquivo: 'allocation-summary',
    },
    conferenciaPercentual: {
      titulo: 'Allocation percentage check',
      descricao:
        "Professionals whose daily allocation sum doesn't hit 100% on some day of the period.",
      periodoAplicado: 'Applied period: {{periodo}}',
      dicaPeriodo: 'Period-based comparison. Default: current month. Max: 12 months.',
      inicio: 'Start',
      fim: 'End',
      bucket: {
        todos: 'All',
        abaixo: 'Below 100%',
        cemPorcento: '100%',
        acima: 'Above 100%',
        zero: 'At 0%',
      },
      incluirZero: 'Include 0% professionals',
      cards: {
        abaixoTitulo: 'Below 100%',
        abaixoDescricao: 'Idle capacity',
        cemTitulo: 'At 100%',
        cemDescricao: 'Fully allocated',
        acimaTitulo: 'Above 100%',
        acimaDescricao: 'Over-allocated',
        zeroTitulo: 'At 0%',
        zeroDescricao: 'No allocation in the period',
        total: '{{count}} professionals in the period',
      },
      colunas: {
        matricula: 'Registration',
        profissional: 'Professional',
        unidade: 'Unit',
        tipoContrato: 'Contract type',
        situacaoContrato: 'Status',
        minimo: 'Min %',
        maximo: 'Max %',
        media: 'Avg %',
        diasAbaixo: 'Days below',
        diasEm100: 'Days at 100%',
        diasAcima: 'Days above',
        classificacao: 'Classification',
      },
      classificacao: {
        zero: '0%',
        below: 'Below',
        at100: '100%',
        above: 'Above',
      },
      detalhes: {
        tituloAdmin: 'Allocations in the period',
        gestorOculto:
          '{{count}} allocation in a project outside your scope is hidden from the detail (system rule). It still counts toward the sum shown above.',
        gestorOcultoPlural:
          '{{count}} allocations in projects outside your scope are hidden from the detail (system rule). They still count toward the sum shown above.',
      },
      filtros: {
        titulo: 'Advanced filters',
        descricao: 'Apply the filters for this query.',
        profissional: 'Professional',
        unidade: 'Unit',
        tipoContrato: 'Contract type',
        situacaoContrato: 'Contract status',
        faixaEntre: '{{field}} between {{min}} and {{max}}',
        faixaMinima: '{{field}} from {{min}}',
        faixaMaxima: '{{field}} up to {{max}}',
      },
      vazioTitulo: 'No deviation in the period',
      vazioDescricao: 'Nobody drifted off 100% in this window. Try a different period or status.',
      exportarTitulo: 'Export percentage check',
      exportarDescricao: 'The current period and filters apply to the file.',
      nomeArquivo: 'allocation-percentage-check',
    },
  },
} as const;
